module.exports = __webpack_public_path__ + "static/image04-800-e7eabfbb437c169f01922695958142b5.jpg";